import { User } from 'mission-control-common-components';
import React from 'react';

import { useCognitoDetails } from '../../../hooks/useCognitoDetails';

export const UserNavLogoutButton = (): React.ReactElement => {
  const cognitoDetails = useCognitoDetails();

  const logout = (): void => {
    User.logout(cognitoDetails);
  };

  return (
    <button className="logout-btn" key="logout" onClick={logout} type="button">
      Logout
    </button>
  );
};
